import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'omnylink-auth',
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'x-client-info': 'omnylink-web',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  db: {
    schema: 'public',
  },
});

// Set up session expiry listener
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN' && session) {
    // Set session expiry to 1 hour from now
    const expiryTime = new Date().getTime() + (60 * 60 * 1000); // 1 hour
    localStorage.setItem('session-expiry', expiryTime.toString());
  }
  
  if (event === 'SIGNED_OUT') {
    // Clear session expiry on sign out
    localStorage.removeItem('session-expiry');
  }
});

// Check session expiry periodically
setInterval(() => {
  const expiryTime = localStorage.getItem('session-expiry');
  if (expiryTime) {
    const now = new Date().getTime();
    if (now > parseInt(expiryTime)) {
      // Session expired, sign out user
      supabase.auth.signOut();
    }
  }
}, 60000); // Check every minute

// Add error handling for failed requests
supabase.handleFailedRequest = async (error: any) => {
  console.error('Supabase request failed:', error);
  
  // Check if error is due to network issues
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network and try again.');
  }

  // Check if error is due to authentication
  if (error.status === 401) {
    await supabase.auth.signOut();
    throw new Error('Your session has expired. Please sign in again.');
  }

  // Handle other errors
  throw new Error('An error occurred while connecting to the server. Please try again later.');
};

export default supabase;